export const styledSystemToTailwindConversionMap: {
    [key: number|string]: string | number;
} = {
    0: "px",
    1: "[2px]",
    2: "[4px]",
    3: "[6px]",
    4: "1",
    5: "8",
    6: "16",
    7: "32",
    8: "64",
};

export const pixelsToTailwindClasses = {
    "0px": 0,
    "2px": "px",
    "4px": 1,
    "8px": 2,
    "12px": 3,
    "16px": 4,
}

export const tailwindConversionMap: { [key: string]: number } = {
    "px": 0,
    "2px": 1,
    "4px": 2,
    "6px": 3,
    "8px": 4,
    "16px": 5,
    "32px": 6,
    "64px": 7,
};